<script lang="ts" setup>
import type { CarDetailsImage } from '@autobid/ui/types/components/CarDetails'
import { replaceImageSize } from '@autobid/ui/utils/car/generateImageSizes'
import { getDetailsImageAlt } from '@autobid/ui/utils/car/getDetailsImageAlt'

interface Props {
  images: CarDetailsImage[]
}

const props = defineProps<Props>()
const { locale } = useI18n()

function prepareRows() {
  return props.images.reduce(
    (acc, el) => {
      let index = acc.length - 1
      const shouldAddNewRow = acc[index].length === 2

      if (shouldAddNewRow) {
        index++
        acc.push([] as unknown as [CarDetailsImage, CarDetailsImage])
      }

      acc[index].push(el)

      return acc
    },
    [[]] as unknown as [CarDetailsImage, CarDetailsImage][],
  )
}

const rows = prepareRows()
</script>

<template>
  <table
    class="w-full border-collapse"
    :style="images.length === 1 ? 'width: 50%' : undefined"
  >
    <tr
      v-for="(row, rowIndex) in rows"
      :key="rowIndex"
      class="break-inside-avoid"
    >
      <td
        v-for="(img, imgIndex) in row"
        :key="img.id"
        class="w-1/2 px-8 pb-6 text-center align-top"
        style="width: 50%"
      >
        <div class="flex w-full flex-col items-center">
          <img
            :data-src="replaceImageSize(img.links.hd, 'hd', 'l')"
            alt=""
            style="height: 220px; max-height: 220px; min-height: 220px"
          >
          <span>
            {{ $t('car-details.pdf.image') }}
            {{ rowIndex * 2 + imgIndex + 1 }}:
            {{ getDetailsImageAlt(img, locale) }}
          </span>
        </div>
      </td>
    </tr>
  </table>
</template>
